/* eslint no-magic-numbers: "off" */
import { exists } from '@engine/lib/utility/exists';
export var DAYS_LIMIT = 100;
export var DAY_START_TIME = {
  hour: 0,
  minute: 0,
  second: 0
};
export var DAY_END_TIME = {
  hour: 23,
  minute: 59,
  second: 59
};
export var FORMAT = 'YYYY-MM-DD HH:mm:ss';
export function clearInputs(from_inputs, to_inputs) {
  function updateDatepickerView($input) {
    if (!$input.attr('value')) {
      $input.val('');
    } else {
      var date = moment($input.val()).format(FORMAT);
      $input.data('DateTimePicker').viewDate(date);
    }
  }

  from_inputs.each(function (key, el) {
    updateDatepickerView($(el));
  });
  to_inputs.each(function (key, el) {
    updateDatepickerView($(el));
  });
}

function getDateInputs() {
  var from = $('[id$="from"]').not('[id$="custom_export_card_valid_from"]');
  var to = $('[id$="to"]').not('[id$="moto"]').not('[id$="boleto"]').not('[id$="baloto"]').not('[id$="crypto"]');
  return {
    from: from,
    to: to
  };
}

export function attachDatePicker() {
  if (exists($('.daterange-picker'))) {
    return;
  }

  var from = getDateInputs().from;
  var to = getDateInputs().to;

  function initBasicDateTimePickers() {
    var $datetimepickers = $('.datetimepicker');

    if (exists($datetimepickers)) {
      $datetimepickers.datetimepicker({
        format: FORMAT,
        sideBySide: true,
        locale: moment.locale(I18n.locale)
      });
    }
  }

  function initDateTimePicker() {
    moment.updateLocale(I18n.locale, {
      week: {
        dow: 1
      }
    });
    var defaultOptions = {
      format: FORMAT,
      sideBySide: true,
      maxDate: moment(DAY_END_TIME),
      locale: moment.locale(I18n.locale)
    };
    var $time_fields = $('[id$="from"], [id$="to"]').not('[id$="moto"]').not('[id$="boleto"]').not('[id$="baloto"]').not('.archived_data').not('[id$="crypto"]');

    if ($time_fields.length === 0) {
      return;
    }

    $time_fields.datetimepicker(defaultOptions);
    $.each(from.not('.archived_data'), function (key, el) {
      var date = moment(DAY_START_TIME).subtract(1, 'M');
      $(el).data('DateTimePicker').defaultDate(date).viewDate(date);
    });
    $.each(to.not('.archived_data'), function (key, el) {
      var date = moment(DAY_END_TIME);
      $(el).data('DateTimePicker').defaultDate(date).viewDate(date);
    });
  }

  function syncTo(minDate, from_date) {
    var dateType = from_date.id.slice(0, -4);
    var to_date = $('#' + dateType + 'to').data('DateTimePicker');
    var range = moment().diff(minDate, 'days');
    var limit = moment().subtract(range - DAYS_LIMIT, 'days');
    var maxDate = range <= DAYS_LIMIT ? moment() : limit;
    to_date.minDate(minDate).maxDate(maxDate.set(DAY_END_TIME));
    var currentDate = to_date.date();

    if (!currentDate) {
      return;
    }

    currentDate.set(DAY_END_TIME);
    to_date.date(currentDate).viewDate(currentDate);
  }

  function syncFrom(maxDate, to_date) {
    var dateType = to_date.id.slice(0, -2);
    var from_date = $('#' + dateType + 'from');
    var minDate = moment(maxDate).subtract(DAYS_LIMIT, 'days').set(DAY_START_TIME);
    from_date.data('DateTimePicker').maxDate(maxDate).minDate(minDate);
  }

  function reset() {
    $.each(to, function (key, el) {
      $(el).data('DateTimePicker').minDate(false).maxDate(moment(DAY_END_TIME)).viewDate(moment()).date(moment()).minDate(false);
    });
    $.each(from, function (key, el) {
      $(el).data('DateTimePicker').minDate(false).maxDate(moment(DAY_END_TIME)).viewDate(moment(DAY_START_TIME).subtract(1, 'M')).date(moment(DAY_START_TIME).subtract(1, 'M')).minDate(false);
    });
  }

  var timeCache = false;

  function clearTimeCache() {
    timeCache = {
      fromTime: false,
      toTime: false
    };
  }

  clearTimeCache();

  function getDateTime(date) {
    return {
      hour: date.get('hour'),
      minutes: date.get('minute'),
      seconds: date.get('second')
    };
  }

  function toggleByPaymentDays(checkbox) {
    var isByPaymentDays = $(checkbox).prop('checked');
    var fromDate = from.data('DateTimePicker').date();
    var toDate = to.data('DateTimePicker').date();
    var fromTime = '';
    var toTime = '';
    var paymentDaysTime = {
      hour: 19,
      minutes: 0,
      seconds: 0
    };
    /*
     * Can not set `by Payment Days` (hours)
     * if the Dates are missing
     */

    if (!fromDate || !toDate) {
      return;
    }

    if (!timeCache.fromTime || !timeCache.toTime) {
      timeCache.fromTime = getDateTime(fromDate);
      timeCache.toTime = getDateTime(toDate);
    }

    if (isByPaymentDays) {
      fromTime = toTime = paymentDaysTime;
    } else {
      fromTime = timeCache.fromTime;
      toTime = timeCache.toTime;
      clearTimeCache();
    }

    from.data('DateTimePicker').date(fromDate.set(fromTime));
    to.data('DateTimePicker').date(toDate.set(toTime));
    from.data('DateTimePicker').viewDate(fromDate.set(fromTime));
    to.data('DateTimePicker').viewDate(toDate.set(toTime));
  }

  initDateTimePicker();
  initBasicDateTimePickers();
  clearInputs(from.not('.archived_data'), to.not('.archived_data'));
  from.not('.archived_data').on('dp.change', function (e) {
    if (e.date) {
      syncTo(e.date, this);
    }
  });
  to.not('.archived_data').on('dp.change', function (e) {
    if (e.date) {
      syncFrom(e.date, this);
    }
  });
  $('form:not([action^="/archived_data"])').find('input[type=reset]').on('click', function () {
    reset();
  });
  $('#by_payment_days').on('click', function () {
    toggleByPaymentDays(this);
  });
}